import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { constants as coreConstants } from '@wsb/guac-widget-core';
import { LIMIT } from '../../constants';
import { SUCCESS, LOADING, EMPTY } from '../../constants/viewStates';
import { initStaticFeedData, isValidFeedUrl } from '../../util';
import useDebouncedFetch from '../useDebouncedFetch';
import { formatData } from '../../util';

const {
  renderModes: { PUBLISH, PREVIEW, ADD, DISPLAY }
} = coreConstants;

export default function useRssFeed({
  env = 'local',
  rssFeedUrl,
  renderMode,
  limit,
  businessName,
  staticContent
}) {
  const [podcast, setPodcast] = useState({});
  const [viewState, setViewState] = useState(LOADING);

  const isPreviewOrPublish = renderMode === PUBLISH || renderMode === PREVIEW;
  const showSampleFeed = () => {
    const data = initStaticFeedData(staticContent.staticFeed, businessName);
    setPodcast(data);
    setViewState(SUCCESS);
  };

  const debouncedFetchPodcast = useDebouncedFetch(
    { limit: isPreviewOrPublish ? limit : LIMIT, env },
    () => {
      if (renderMode === DISPLAY) {
        return showSampleFeed();
      }
      setViewState(EMPTY);
    },
    data => {
      const sanitizedDate = formatData(data);
      setPodcast(sanitizedDate);
      setViewState(SUCCESS);
    }
  );

  useEffect(() => {
    if (isValidFeedUrl(rssFeedUrl)) {
      setViewState(LOADING);
      debouncedFetchPodcast(rssFeedUrl);
    } else if (renderMode === ADD || renderMode === DISPLAY) {
      showSampleFeed();
    } else {
      setViewState(EMPTY);
    }
  }, [rssFeedUrl]);

  return {
    viewState,
    podcast
  };
}

useRssFeed.propTypes = {
  env: PropTypes.string,
  rssFeedUrl: PropTypes.string,
  limit: PropTypes.string,
  renderMode: PropTypes.string,
  businessName: PropTypes.string,
  staticContent: PropTypes.object
};
